import { IReward } from './IReward';
import { Reward } from './Reward';
import { Tier } from './Tier';

export class InterestReward extends Reward {
	public static readonly CLASS: string = 'com.bancvue.rcx.config.product.rewards.api.InterestReward';

	public static readonly NAME: string = 'Interest';

	nonQualifyingApr: string | null = null;

	tier1: Tier = { apr: '' }

	tier2?: Tier | null = null;

	tier3?: Tier | null = null;

	constructor(reward?: IReward) {
	  super(InterestReward.CLASS, reward ? reward.id : null);

	  if (reward) {
	    this.tier1 = (reward as any).tier1;
	    this.tier2 = (reward as any).tier2;
	    this.tier3 = (reward as any).tier3;
	  }
	}

	getDescription(): string {
	  if (this.tier3 && this.tier2 && this.tier1) {
	    return `${this.tier1.apr}% up to $${this.tier1.cap} and ${this.tier2.apr}% up to $${this.tier2.cap} and ${this.tier3.apr}% over`;
	  } if (this.tier2 && this.tier1) {
	    return `${this.tier1.apr}% up to $${this.tier1.cap} and ${this.tier2.apr}% over`;
	  } if (this.tier1) {
	    return `${this.tier1.apr}% on entire balance`;
	  }

	  return '';
	}

	clone(): IReward {
	  const clone = new InterestReward();
	  Object.assign(clone, this);

	  clone.tier1 = InterestReward.cloneTier(this.tier1)!;
	  clone.tier2 = InterestReward.cloneTier(this.tier2);
	  clone.tier3 = InterestReward.cloneTier(this.tier3);

	  return clone;
	}

	private static cloneTier(sourceTier?: Tier | null): Tier | null | undefined {
	  if (sourceTier) {
	    return {
	      apr: sourceTier.apr,
	      cap: sourceTier.cap,
	    };
	  }
	  return null;
	}
}

export default InterestReward;
